export enum MeterType {
  HV = 'HV',
  MV = 'MV',
}
export const meterTypeToLabel = {
  [MeterType.HV]: 'HV',
  [MeterType.MV]: 'MV',
};
